/* Printify PocketPrint — product page blocks */
(function () {
  'use strict';

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.pf-reveal:not([data-pf-observed])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-pf-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) {
      el.setAttribute('data-pf-observed', '1');
      io.observe(el);
    });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdown(root) {
    var nodes = (root || document).querySelectorAll('[data-pf-countdown]:not([data-pf-running])');
    nodes.forEach(function (node) {
      node.setAttribute('data-pf-running', '1');
      var minutes = parseInt(node.getAttribute('data-pf-minutes') || '180', 10);
      var key = 'pf_deadline_' + (node.getAttribute('data-pf-key') || 'default');
      var deadline = 0;
      try { deadline = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      var now = Date.now();
      if (!deadline || isNaN(deadline) || deadline <= now) {
        deadline = now + minutes * 60 * 1000;
        try { localStorage.setItem(key, String(deadline)); } catch (e) {}
      }
      var h = node.querySelector('[data-pf-h]');
      var m = node.querySelector('[data-pf-m]');
      var s = node.querySelector('[data-pf-s]');
      function tick() {
        var left = deadline - Date.now();
        if (left <= 0) {
          deadline = Date.now() + minutes * 60 * 1000;
          try { localStorage.setItem(key, String(deadline)); } catch (e) {}
          left = minutes * 60 * 1000;
        }
        var total = Math.floor(left / 1000);
        if (h) h.textContent = pad(Math.floor(total / 3600));
        if (m) m.textContent = pad(Math.floor((total % 3600) / 60));
        if (s) s.textContent = pad(total % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initAtc(root) {
    var btns = (root || document).querySelectorAll('[data-pf-atc]:not([data-pf-bound])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-pf-bound', '1');
      btn.addEventListener('click', function (e) {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        var submit = form.querySelector('[type="submit"]:not([disabled])');
        if (submit) { submit.click(); }
        else if (form.requestSubmit) { form.requestSubmit(); }
        else { form.submit(); }
      });
    });
  }

  function init(root) {
    initReveal(root);
    initCountdown(root);
    initAtc(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
